<template>
  <div id="alert">
    <div class="modal center-hor align-ver" v-on:click="closeAlert">
      <div class="modal-dialog bg-light padding-15 margin-10 radius-10">
        <img src="@/assets/alert.png" v-if="!alertInfo">
        <p>{{model}}</p>
      </div>
    </div>
  </div>
</template>
<script>
  import { globals } from "@/mixins/globals"
  export default {
    mixins: [globals],
    props: {
      model: String
    }
  }
</script>